import { axios } from "@/lib/axios";

import { MeResponse } from "../types";

export const getMe = async (): Promise<MeResponse> => {
  return await axios.get("/users/me");
};
